<template>
  <modal 
  name="customer-modal-survey"
  height="auto"
  width="70%"
  class="customSurveyModal"
  :scrollable="true"
  :adaptive="true"
  :min-width="350"
  @before-open="beforeOpen"
  @closed="closed">
    <div class="row7">
      <div class="inner">
        <header class="modalHeader flex flexAlignS">
          <p>설문지 제출</p>
          <button @click="onClickCancel"></button>
        </header>
        <div class="topContents">
          <div class="subDate flex">
            <div class="dateTxt">
              <p>
                등록일:
                <span>{{survey.regDate}}</span>
              </p>
            </div>
            <div class="dateTxt">
              <p>
                시작일:
                <span>{{survey.startDate}}</span>
              </p>
            </div>
            <div class="dateTxt">
              <p>
                종료일:
                <span>{{survey.endDate}}</span>
              </p>
            </div>
          </div>
          <div class="customerSurveyTitle">
            <p>
              {{survey.title}}
            </p>
            <hr class="popupHr">
          </div>
        </div>
        <div class="introductionTxt">
                <h5>
                    {{ survey.introduction }}
                </h5>
                <section class="surveyArea lastChildNotMg">
                    <fieldset :disabled="isSubmited">
                    <component
                        v-for="item in survey.items"
                        :key="item.order"
                        :is="bindComponent(item)"
                        v-bind:item="item"
                        v-bind:status="status">
                    </component>
                    </fieldset>
                </section>
            </div>
      </div>
      
      <div class="modalFooterBtn btnBox">
        <button @click="onClickModify" :class="[{'grayBtn':isSubmited || isExpired(this.survey.endDate)}, {'greenBtn': !isSubmited && !isExpired(this.survey.endDate)}]" :disabled="isSubmited || isExpired(this.survey.endDate)">임시저장</button>
        <button @click="onClickSave" :class="[{'grayBtn':isSubmited || isExpired(this.survey.endDate)}, {'redBtn': !isSubmited && !isExpired(this.survey.endDate)}]" :disabled="isSubmited || isExpired(this.survey.endDate)">제출</button>
        <button @click="onClickCancel" class="redborderBtn">취소</button>
      </div>
    </div>
  </modal>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex'
import * as surveyUtil from '@/utils/surveyUtil'
import Short from './Short.vue'
import Multiple from './Multiple.vue'
import Check from './Check.vue'
import Linear from './Linear.vue'
import * as validationUtil from '@/utils/validationUtil'

export default {
  name: 'CustomerModalSurvey',
  components:{
    Short,
    Multiple,
    Check,
    Linear
  },
  props:[
    'surveyIdx',
    'isSubmited'
  ],
  data(){
    return{
      modalResult: false
    }
  },
  computed:{
    ...mapState('auth',[
      'user'
    ]),
    ...mapState('survey',[
      'survey'
    ]),
    status(){
      return surveyUtil.getStatus(this.survey.startDate, this.survey.endDate)
    }
  },
  mounted(){
    this.show()
  },
  methods:{
    ...mapMutations('survey', [
      'setSurvey',
      'resetSurvey'
    ]),
    ...mapActions('survey', [
      'requestDetail',
      'saveAnswer'
    ]),
    show(){
      this.$modal.show('customer-modal-survey')
    },
    hide(){
      this.$modal.hide('customer-modal-survey')
    },
    beforeOpen(){
      this.init()
    },
    closed(){
      this.$emit('modal-closed', this.$options.name, {result: this.modalResult})
    },
    init(){
      this.resetSurvey()

      if(validationUtil.isEmpty(this.surveyIdx) ||
      validationUtil.isEmpty(this.user) ||
      validationUtil.isEmpty(this.user.idx)){
        return
      }

      const surveyIdx = Number(this.surveyIdx)
      const userIdx = Number(this.user.idx)

      this.requestDetail({
        surveyIdx: surveyIdx,
        userIdx: userIdx
      })
      .catch(() => {
        this.$alert('알림', '데이터를 가져올 수 없습니다.')
      })
    },
    bindComponent(item){
      switch(item.type){
        case 'SHORT':
          return Short
        case 'MULTIPLE':
          return Multiple
        case 'CHECK':
          return Check
        case 'LINEAR':
          return Linear
        default:
          return null
      }
    },
    doSave(isFinal){
      this.saveAnswer({
        surveyIdx: this.surveyIdx,
        userIdx: this.user.idx,
        answerJsonString: JSON.stringify(this.survey),
        isFinal: isFinal
      })
      .then(response => {
        var data = response.data
        if(data.RESULT == true){
          this.$alert('알림', '저장되었습니다.', null, {
            'closed': () => {
              this.modalResult = true
              this.hide()  
            }
          })
        }
        else{
          this.$alert('알림', '데이터 저장을 실패했습니다. ERROR: '+data.ERROR)
        }
      })
      .catch(() => {
        this.$alert('알림', '요청을 실패했습니다.')
      })
    },
    onClickModify(){      
      this.doSave(false)
    },
    onClickSave(){
      const items = this.survey.items
      for(var i = 0; i < items.length; i++){
        var item = items[i]
        if(item.essential == 'Y'){
          if(validationUtil.isEmpty(item.answer.data)){
            this.$alert('알림', '필수 항목을 입력해주세요.')
            return
          }
        }
      }
      
      var response = this.$createConfirmResponse()

      this.$confirm('알림', '제출된 설문지는 수정될 수 없습니다.', '확인', '취소', response, {
        'closed': ()=>{
          if(response.result == true){
            this.doSave(true)
          }
        }
      })
    },
    onClickCancel(){
      this.hide() 
    },
    isExpired(date){
       if(date != null && date != ''){
          var today = new Date();
          var endDate = new Date(date + ' 23:59:59')
          
          if(today.getTime() > endDate.getTime()){
            return true
          }
        }

        return false
    }
  }
}
</script>